// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `wfm-task-progress {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}

wfm-plan-loading-overlay {
  background: white;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 50;
}

.toolbar-container {
  justify-content: space-between;
}

.table-list {
  border: 1px solid #c1bebe;
}

.mu-multiselect {
  min-width: 250px;
}

:host ::ng-deep .toolbar-container button.btn {
  margin: 0px 8px 0 0;
}

.icon {
  font-size: 20px;
}

.action-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
}

:host ::ng-deep .ag-header-cell {
  color: #98A2B3;
  font-weight: bold;
}

:host ::ng-deep .ag-ltr .ag-row-group-leaf-indent {
  --ag-row-group-indent-size:0;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/plan/new-hire/new-hire.component.scss","webpack://./../PSR%20ESP%20WebApp%20Build/src/app/pages/plan/new-hire/new-hire.component.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;ACAF;;ADGA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;ACAF;;ADGA;EACE,8BAAA;ACAF;;ADGA;EACE,yBAAA;ACAF;;ADGA;EACE,gBAAA;ACAF;;ADGA;EACE,mBAAA;ACAF;;ADEA;EACE,eAAA;ACCF;;ADCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;ACEF;;ADCA;EACE,cAAA;EACA,iBAAA;ACEF;;ADCA;EACE,4BAAA;ACEF","sourcesContent":["\nwfm-task-progress{\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n}\n\nwfm-plan-loading-overlay {\n  background: white;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  z-index: 50;\n}\n\n.toolbar-container{\n  justify-content: space-between;\n}\n\n.table-list{\n  border: 1px solid #c1bebe;\n}\n\n.mu-multiselect {\n  min-width:250px;\n}\n\n:host ::ng-deep .toolbar-container button.btn{\n  margin: 0px 8px 0 0;\n}\n.icon{\n  font-size:20px;\n}\n.action-buttons{\n  display:flex;\n  align-items: center;\n  justify-content: center;\n  width:100px;\n}\n\n:host ::ng-deep .ag-header-cell{\n  color: #98A2B3;\n  font-weight: bold;\n}\n\n:host ::ng-deep .ag-ltr .ag-row-group-leaf-indent{\n  --ag-row-group-indent-size:0;\n}","wfm-task-progress {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 1;\n}\n\nwfm-plan-loading-overlay {\n  background: white;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  z-index: 50;\n}\n\n.toolbar-container {\n  justify-content: space-between;\n}\n\n.table-list {\n  border: 1px solid #c1bebe;\n}\n\n.mu-multiselect {\n  min-width: 250px;\n}\n\n:host ::ng-deep .toolbar-container button.btn {\n  margin: 0px 8px 0 0;\n}\n\n.icon {\n  font-size: 20px;\n}\n\n.action-buttons {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100px;\n}\n\n:host ::ng-deep .ag-header-cell {\n  color: #98A2B3;\n  font-weight: bold;\n}\n\n:host ::ng-deep .ag-ltr .ag-row-group-leaf-indent {\n  --ag-row-group-indent-size:0;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
